export const Dot = ({ color }: { color: string }) => <div className={`rounded w-2 h-2 mr-2 ${color}`} />;
